// extracted by mini-css-extract-plugin
export var dividerContainer = "_7h-0";
export var line = "_7h-1";